import React, { useState } from 'react';

const ContactUs = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form submitted:', formData);
        setSubmitted(true);
        setFormData({ name: '', email: '', subject: '', message: '' });
        setTimeout(() => setSubmitted(false), 5000);
    };

    return (
        <>
            <style>{`
                body {
                    background-color: #121212;
                    color: #e0e0e0;
                    font-family: 'Inter', sans-serif;
                }

                .legal-container {
                    background-color: #1f1f1f;
                    padding: 2rem;
                    border-radius: 0.5rem;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
                    max-width: 900px;
                    margin: 2rem auto;
                    color: #a5a6ad;
                    font-size: 0.95rem;
                    line-height: 1.6;
                }

                .company-name {
                    font-size: 1.2rem;
                    font-weight: 500;
                    color: #9e9e9e;
                    margin-bottom: 0.5rem;
                    display: block;
                }
                
                .legal-container h2 {
                    font-size: 2rem;
                    font-weight: 700;
                    color: #ffffff;
                    border-bottom: 2px solid #333;
                    padding-bottom: 0.75rem;
                    margin-bottom: 2rem;
                }
                
                .legal-container h3 {
                    font-size: 1.5rem;
                    font-weight: 600;
                    color: #f0f0f0;
                    margin-top: 2.5rem;
                    margin-bottom: 1rem;
                }
                
                .legal-container p {
                    margin-bottom: 1.2rem;
                    color: #b0b0b0;
                }

                .contact-grid {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 2rem;
                    margin-top: 2rem;
                }

                .contact-info {
                    background-color: #2a2a31;
                    padding: 1.5rem;
                    border-radius: 0.5rem;
                    border-left: 4px solid #4a90e2;
                }

                .contact-item {
                    margin-bottom: 1rem;
                    padding: 0.5rem 0;
                    border-bottom: 1px solid #333;
                }

                .contact-item strong {
                    color: #4a90e2;
                    display: block;
                    margin-bottom: 0.25rem;
                }

                .contact-form {
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                }

                .form-input,
                .form-textarea {
                    background-color: #2a2a31;
                    border: 1px solid #333;
                    border-radius: 0.5rem;
                    padding: 0.75rem;
                    color: #e0e0e0;
                    font-family: 'Inter', sans-serif;
                    font-size: 0.95rem;
                    transition: all 0.3s ease;
                }

                .form-input:focus,
                .form-textarea:focus {
                    outline: none;
                    border-color: #4a90e2;
                    box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
                }

                .form-textarea {
                    resize: vertical;
                    min-height: 120px;
                }

                .submit-button {
                    background-color: #4a90e2;
                    color: white;
                    border: none;
                    border-radius: 0.5rem;
                    padding: 0.75rem;
                    font-size: 1rem;
                    font-weight: 600;
                    cursor: pointer;
                    transition: background-color 0.3s ease;
                }

                .submit-button:hover {
                    background-color: #357abd;
                }

                .success-message {
                    background-color: rgba(74, 144, 226, 0.1);
                    border: 1px solid #4a90e2;
                    border-radius: 0.5rem;
                    padding: 1rem;
                    margin-bottom: 1rem;
                    color: #4a90e2;
                    text-align: center;
                }

                @media (max-width: 768px) {
                    .contact-grid {
                        grid-template-columns: 1fr;
                    }
                }
            `}</style>
            <div className="legal-container">
                <span className="company-name">CommunityofHubs</span>
                <h2>Contact Us</h2>
                <p>We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>

                {submitted && (
                    <div className="success-message">
                        Thank you for your message! We'll get back to you soon.
                    </div>
                )}

                <div className="contact-grid">
                    <div className="contact-info">
                        <h3 style={{ fontSize: '1.25rem', marginBottom: '1rem', color: '#fff' }}>Get in Touch</h3>
                        
                        <div className="contact-item">
                            <strong>Email:</strong>
                            <span>e.communityhubs@gmail.com</span>
                        </div>
                        
                        <div className="contact-item">
                            <strong>Phone:</strong>
                            <span>+91 9850083751</span>
                        </div>
                        
                        <div className="contact-item">
                            <strong>Address:</strong>
                            <span>Rajdhani Complex, Office no. 409, 4th Floor, Pune - Satara Rd, Near Shankar Maharaj Math, Pune, Maharashtra</span>
                        </div>
                        
                        <div className="contact-item">
                            <strong>Business Hours:</strong>
                            <span>Monday - Friday, 9:00 AM - 6:00 PM</span>
                        </div>
                    </div>

                    <form className="contact-form" onSubmit={handleSubmit}>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Your Name"
                            className="form-input"
                            required
                        />
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Your Email"
                            className="form-input"
                            required
                        />
                        <input
                            type="text"
                            name="subject"
                            value={formData.subject}
                            onChange={handleChange}
                            placeholder="Subject"
                            className="form-input"
                            required
                        />
                        <textarea
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            placeholder="Your Message"
                            className="form-textarea"
                            required
                        />
                        <button type="submit" className="submit-button">
                            Send Message
                        </button>
                    </form>
                </div>
            </div>
        </>
    );
};

export default ContactUs;